export default {
    header: 'Timetable setting',
    workday: 'Workday',
    specialWorkday: 'Special Workday',
    holiday: 'Holiday'
}
